import { filter, find, get, orderBy } from 'lodash';
import { useParams } from 'react-router-dom';

import { useGetListsQuery } from 'app/apis/lists.api';
import { Lists, AdvancedSearchDateTypes } from 'common-components/form-inputs/list-autocomplete';

const useListMapper = () => {
  const { lang } = useParams();
  const { data: lists, isLoading } = useGetListsQuery({ lang });
  const getListItems = (listName) => {
    if(listName === Lists.AdvancedSearchDateType) {
      return AdvancedSearchDateTypes;
    }
    return get(lists, listName, []);
  };

  const mapToList = (listName, val) => {
    if (listName === Lists.Years) {
      return val;
    }

    for (const key in Lists) {
      if (Lists[key] === listName) {
        const listItems = get(lists, listName, []);
        return find(listItems, cv => cv.id === val)?.name
      }
    }

    return val;

  }

  return { mapToList, getListItems };
};

export default useListMapper;
